/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsjoinersaccounts2Inputs */

const en_statsjoinersaccounts2 = /** @type {(inputs: Statsjoinersaccounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With an account`)
};

const de_statsjoinersaccounts2 = /** @type {(inputs: Statsjoinersaccounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Konto`)
};

/**
* | output |
* | --- |
* | "With an account" |
*
* @param {Statsjoinersaccounts2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsjoinersaccounts2 = /** @type {((inputs?: Statsjoinersaccounts2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsjoinersaccounts2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsjoinersaccounts2(inputs)
	return de_statsjoinersaccounts2(inputs)
});
export { statsjoinersaccounts2 as "statsJoinersAccounts" }